export default __webpack_public_path__ + "static/media/whitelogo.49d0c172.png";